module.exports = __webpack_public_path__ + "66817da5373c5dd26515454c9c8a1c47.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-chef.png
// module id = 3385
// module chunks = 0